import { FarmCards } from 'app/agriculture/routes/BackOffice/UserHome/components/FarmCards/FarmCards';
import { useFarms } from 'app/agriculture/hooks/useFarms/useFarms';
import { Title } from 'app/agriculture/components/Title/Title';
import { Subtitle } from 'app/agriculture/components/Subtitle/Subtitle';
import { UserInvitations } from 'app/agriculture/routes/BackOffice/UserHome/components/UserInvitations/UserInvitations';
import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';

export function UserHome() {
    const farms = useFarms();
    const title = farms.length === 0 ? 'No Farms Yet' : 'Your Farms';
    const subtitle =
        farms.length === 0
            ? 'Looks like you haven’t added a farm yet. Get started by creating your first farm.'
            : 'Manage your existing farms, or if you want, add a new farm.';

    return (
        <BackOfficeContent>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
            <UserInvitations />
            <FarmCards />
        </BackOfficeContent>
    );
}
